<template>
    <div class="my-profile">
        <navigation />
        <router-view />
    </div>
</template>

<script>
import navigation from "./components/navigation.vue";
export default {
    name : 'myProfile',

    components : {
        navigation
    }
}
</script>

<style scoped lang="scss">
.my-profile {
    background-color: white;
}
</style>